import React, { useState } from 'react';
import './ReaderProfile.css';

const ReaderProfile = ({ reader, borrowings, books, onBack }) => {
  const [activeTab, setActiveTab] = useState('overview'); // 'overview', 'borrowings', 'history', 'fines'

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-HK');
  };

  const calculateFine = (dueDate) => {
    const due = new Date(dueDate);
    const today = new Date();
    const diffTime = today - due;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays * 2 : 0; // $2 per day
  };

  const getBookTitle = (bookId) => {
    const book = books.find(b => b.id === bookId);
    return book ? book.title : '未知圖書';
  };

  const getBookCallNumber = (bookId) => {
    const book = books.find(b => b.id === bookId);
    return book ? (book.call_number || book.callNumber || 'N/A') : 'N/A';
  };

  const currentBorrowings = borrowings.filter(b => b.status === 'borrowed');
  const returnedBooks = borrowings.filter(b => b.status === 'returned');
  const overdueBooks = currentBorrowings.filter(b => {
    const dueDate = new Date(b.due_date || b.dueDate);
    const today = new Date();
    return dueDate < today;
  });

  const totalFine = overdueBooks.reduce((sum, borrowing) => {
    return sum + calculateFine(borrowing.due_date || borrowing.dueDate);
  }, 0);

  const renderOverview = () => (
    <div className="overview-section">
      <div className="reader-card">
        <div className="card-header">
          <div className="card-photo">
            {reader.photoUrl ? (
              <img src={reader.photoUrl} alt={reader.name} />
            ) : (
              <div className="photo-placeholder">
                <span>👤</span>
              </div>
            )}
          </div>
                     <div className="card-info">
             <h3>{reader.display_name || reader.user?.email || '未知讀者'}</h3>
             <p className="english-name">{reader.user?.email || ''}</p>
             <p className="student-id">{reader.student_number || reader.reader_number || 'N/A'}</p>
             <p className="class-info">{reader.class_info || 'N/A'} - {reader.grade || 'N/A'}</p>
           </div>
        </div>
        <div className="card-body">
          <div className="card-details">
            <div className="detail-item">
              <span className="label">圖書證號:</span>
              <span className="value">{reader.reader_number || reader.libraryCardNumber || 'N/A'}</span>
            </div>
            <div className="detail-item">
              <span className="label">加入日期:</span>
              <span className="value">{reader.created_at ? formatDate(reader.created_at) : (reader.joinDate ? formatDate(reader.joinDate) : 'N/A')}</span>
            </div>
            <div className="detail-item">
              <span className="label">狀態:</span>
              <span className={`status-badge ${reader.membership_status || reader.status}`}>
                {(reader.membership_status || reader.status) === 'active' ? '活躍' : '非活躍'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📚</div>
          <div className="stat-content">
            <div className="stat-value">{reader.currentBooks}</div>
            <div className="stat-label">目前借閱</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📖</div>
          <div className="stat-content">
            <div className="stat-value">{reader.maxBooks}</div>
            <div className="stat-label">最大借閱量</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <div className="stat-value">{reader.totalBorrowed}</div>
            <div className="stat-label">總借閱次數</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <div className="stat-value">{reader.overdueCount}</div>
            <div className="stat-label">逾期次數</div>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h4>快速操作</h4>
        <div className="action-buttons">
          <button className="action-btn primary">借書</button>
          <button className="action-btn secondary">續借</button>
          <button className="action-btn warning">繳納罰款</button>
          <button className="action-btn info">列印借書證</button>
        </div>
      </div>
    </div>
  );

  const renderCurrentBorrowings = () => (
    <div className="borrowings-section">
      <h3>目前借閱</h3>
      {currentBorrowings.length === 0 ? (
        <p className="no-borrowings">目前沒有借閱的圖書</p>
      ) : (
        <div className="borrowings-list">
                     {currentBorrowings.map(borrowing => {
             const book = books.find(b => b.id === (borrowing.book_id || borrowing.bookId));
             const isOverdue = new Date(borrowing.due_date || borrowing.dueDate) < new Date();
             const fine = isOverdue ? calculateFine(borrowing.due_date || borrowing.dueDate) : 0;

            return (
              <div key={borrowing.id} className={`borrowing-item ${isOverdue ? 'overdue' : ''}`}>
                <div className="book-info">
                  <h4>{book?.title}</h4>
                                     <p className="call-number">索書號: {getBookCallNumber(book?.id)}</p>
                   <p className="borrow-date">借閱日期: {formatDate(borrowing.checkout_date || borrowing.borrowDate)}</p>
                   <p className={`due-date ${isOverdue ? 'overdue' : ''}`}>
                     到期日期: {formatDate(borrowing.due_date || borrowing.dueDate)}
                   </p>
                                     {borrowing.renewed_count > 0 && <span className="renewed-badge">已續借</span>}
                  {isOverdue && <span className="overdue-badge">已逾期</span>}
                </div>
                <div className="borrowing-actions">
                  {isOverdue && (
                    <div className="fine-info">
                      <span className="fine-amount">罰款: ${fine}</span>
                    </div>
                  )}
                  <button className="action-btn renew">續借</button>
                  <button className="action-btn return">還書</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  const renderBorrowingHistory = () => (
    <div className="history-section">
      <h3>借閱歷史</h3>
      {returnedBooks.length === 0 ? (
        <p className="no-history">沒有借閱歷史記錄</p>
      ) : (
        <div className="history-list">
                     {returnedBooks.map(borrowing => {
             const book = books.find(b => b.id === (borrowing.book_id || borrowing.bookId));
             const wasOverdue = new Date(borrowing.due_date || borrowing.dueDate) < new Date(borrowing.return_date || borrowing.returnDate);

            return (
              <div key={borrowing.id} className="history-item">
                <div className="book-info">
                  <h4>{book?.title}</h4>
                                     <p className="call-number">索書號: {getBookCallNumber(book?.id)}</p>
                   <p className="borrow-date">借閱日期: {formatDate(borrowing.checkout_date || borrowing.borrowDate)}</p>
                   <p className="return-date">歸還日期: {formatDate(borrowing.return_date || borrowing.returnDate)}</p>
                  {wasOverdue && <span className="overdue-badge">曾逾期</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  const renderFines = () => (
    <div className="fines-section">
      <h3>罰款記錄</h3>
      {overdueBooks.length === 0 ? (
        <p className="no-fines">目前沒有罰款記錄</p>
      ) : (
        <div className="fines-list">
          <div className="fines-summary">
            <h4>罰款總計: ${totalFine}</h4>
            <p>逾期圖書: {overdueBooks.length} 本</p>
          </div>
                     {overdueBooks.map(borrowing => {
             const book = books.find(b => b.id === (borrowing.book_id || borrowing.bookId));
             const fine = calculateFine(borrowing.due_date || borrowing.dueDate);

            return (
              <div key={borrowing.id} className="fine-item">
                <div className="book-info">
                  <h4>{book?.title}</h4>
                                     <p className="call-number">索書號: {getBookCallNumber(book?.id)}</p>
                   <p className="due-date">到期日期: {formatDate(borrowing.due_date || borrowing.dueDate)}</p>
                  <p className="fine-amount">罰款: ${fine}</p>
                </div>
                <div className="fine-actions">
                  <button className="action-btn pay">繳納罰款</button>
                  <button className="action-btn return">還書</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <div className="reader-profile">
      <div className="profile-header">
        <button className="back-button" onClick={onBack}>
          ← 返回目錄
        </button>
        <h2>讀者資料</h2>
      </div>

      <div className="profile-tabs">
        <button
          className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          概覽
        </button>
        <button
          className={`tab-button ${activeTab === 'borrowings' ? 'active' : ''}`}
          onClick={() => setActiveTab('borrowings')}
        >
          目前借閱
        </button>
        <button
          className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          借閱歷史
        </button>
        <button
          className={`tab-button ${activeTab === 'fines' ? 'active' : ''}`}
          onClick={() => setActiveTab('fines')}
        >
          罰款記錄
        </button>
      </div>

      <div className="profile-content">
        {activeTab === 'overview' && renderOverview()}
        {activeTab === 'borrowings' && renderCurrentBorrowings()}
        {activeTab === 'history' && renderBorrowingHistory()}
        {activeTab === 'fines' && renderFines()}
      </div>
    </div>
  );
};

export default ReaderProfile;
